import jp from "jsonpath";
import store from '@/serviforms/designer/store';
import { updatePages, getAllPages, getQuestionsByPage, getAllQuestion } from "@/serviforms/designer/indexDB/logic.js";
import { confirm } from "../helpers/";

const fixFlexible = async () => {
    const allPages = await getAllPages()
    const getQuestions = await getAllQuestion();
    let allPromise = []

    if (!await verifyFlex()) {
        return false
    }

    for (const i in allPages) {
        const { questions, key } = allPages[i]

        const resultPage = fixRelated(questions, getQuestions)
        allPromise.push(updatePages(key, resultPage))
    }

    await Promise.all(allPromise)
    store.state.questionsByPage = await getQuestionsByPage()

    if (! await verifyFlex()) {
        return false
    }

    return true
}

const verifyFlex = async () => {
    const getQuestions = await getAllQuestion();
    const query = '$[?(@.inputType === "flex" && @.type === "input" && @.related.question === -1)]';
    const related = jp.query(getQuestions, query);


    if (related === undefined || related === null || related === '' || related.length > 0) {
        const names = related.map(({ name }) => name)
        const msg = `Las siguientes preguntas flexibles requieren revincularlas: ${ names.join()}`
        confirm({ title: "Alerta", text: msg, type: "alert" })
        return false
    }
    return true
}

const fixRelated = (questions, allQuestions) => {
    return questions.map(question => {
        const { type, inputType } = question
        if (type === 'input' && inputType === 'flex') {
            const name = question.related.name
            const indice = allQuestions.findIndex(question => question.name === name)
            if (indice === -1) {
                return fixQuestionFlex(question)
            }
        }

        return question
    })
}

const fixQuestionFlex = (question) => {
    let related = question.related;
    delete related.type
    return {
        ...question,
        inherited: [],
        related: {
            ...related,
            name: question.name,
            answers: [],
            question: -1,
        },
    }
}

export {
    fixFlexible
}
